import React from 'react';
import styled from '../../styles/styled-components';
import { Switch } from '../switch';
import uniqueId from 'lodash/uniqueId';

type ShowPresenseToggleProps = {
  showPresenceToUser: boolean;
  onShowPresenceToUserChange: (showPresence: boolean) => void;
};

const showPresenceToUserSwitchId = uniqueId('showPresenceToUserSwitch_');

export const ShowPresenceToggle: React.SFC<ShowPresenseToggleProps> = ({
  showPresenceToUser,
  onShowPresenceToUserChange,
  ...rest
}) => (
  <>
    <ToggleLabel htmlFor={showPresenceToUserSwitchId}>
      Session Indicator
    </ToggleLabel>
    <StyledSwitch
      id={showPresenceToUserSwitchId}
      checked={showPresenceToUser}
      onChange={onShowPresenceToUserChange}
    />
  </>
);

const ToggleLabel = styled.label`
  font-weight: normal;
  margin-right: 10px;
  margin-top: 4px;
`;

const StyledSwitch = styled(Switch)``;
